import { useShop } from "./ShopContext";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";

import {
  Button,
  Offcanvas
} from "react-bootstrap";

export default function ShopCartButton({ isMobile }) {
  const { data, cart } = useShop();
  const navigate = useNavigate();
  const [ cartIsOpen, setCartIsOpen] = useState(false);

  // Add useEffect to handle window event setup
  useEffect(() => {
    window.onFSPopupClosed = function (orderReference) {
      if (window.fastspring && window.fastspring.builder) {
        window.fastspring.builder.reset();
      }
      
      if (orderReference && orderReference.id) {
        navigate("/messageview", { 
          state: { 
            message: "Thanks for your purchase. " 
          } 
        });
      }
    };

    // Cleanup function to remove the handler when component unmounts
    return () => {
      if (typeof window !== "undefined") {
        window.onFSPopupClosed = null;
      }
    };
  }, [navigate]); // Add navigate to dependencies array

  const checkout = () => {
    // Check if window object is defined before using it
    if (
      typeof window !== "undefined" &&
      window.fastspring &&
      window.fastspring.builder
    ) {
      // Push the payload to add the product
      window.fastspring.builder.checkout();
    }
  };

  // Re-pushes the session so FastSpring sends back freshly calculated totals (e.g. tax)
  const refreshCart = () => {
    if (
      typeof window !== "undefined" &&
      window.fastspring &&
      window.fastspring.builder
    ) {
      window.fastspring.builder.push({});
    }
  };

  const removeItem = (path) => {
    // Check if window object is defined before using it
    if (
      typeof window !== "undefined" &&
      window.fastspring &&
      window.fastspring.builder
    ) {
      // Push the payload to add the product
      window.fastspring.builder.remove(path);
    }
  };

  return (
    <>
      <Button className="showCartButton position-relative" onClick={ e => { refreshCart(); setCartIsOpen(true); } } style={{  background: "0x0", width: "60px", padding: "0px", marginLeft:  isMobile ? 0 : 10, marginRight: isMobile ? 24 : 70}}>
        <i className="material-icons" >shopping_cart</i>
        <span className="position-absolute top-1 start-10 badge rounded-pill" style={{ marginTop: "2px", color: "#FFFFFFBB", background: "#1c5480" }}>
          {
            cart.length
          }
          <span className="visually-hidden">number of items in cart</span>
          </span>
      </Button>

      <Offcanvas placement="end" show={ cartIsOpen } onHide={e => setCartIsOpen(false)} style={{ minWidth: "450px" }}>
        <Offcanvas.Header  closeButton>
          <Offcanvas.Title style={{ paddingLeft: "12px", marginTop: "10px"}}>CART</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <div className="cart-items-list" style={{ minWidth: "410px" }}>
          {cart.length === 0 ? (
            <div style={{ textAlign: "center" }}>Your cart is empty</div>
          )
            :
            (
              cart.map(item => (
                <div key={item.path} className="cart-item row">
                  <div className="col" style={{ minWidth: "170px", whiteSpace: "nowrap" }}>
                    <span>{item.display}</span>
                  </div>
                  <div className="col" style={{ minWidth: "70px", whiteSpace: "nowrap", textAlign: "right" }}>
                    {item.discountPercentValue > 0 && (
                      <small><small><s>{item.priceValueWithoutTaxAndDiscounts.toFixed(2)}</s></small></small>
                    )}
                  </div>
                  <div className="col" style={{ minWidth: "90px", whiteSpace: "nowrap", textAlign: "right" }}>
                    {item.priceValueWithoutTax.toFixed(2)}
                  </div>
                  <div className="col" style={{ minWidth: "28px", padding: "0px"  }}>
                    {data.currency}
                  </div>
                  <div className="col">
                  
                    <Button variant="none" className="cart-item-delete-button" style={{ padding: "0", offsetposition: "0px 0px" }} onClick={() => removeItem(item.path)}><i className="material-icons">close</i></Button>
                  </div>
                </div>
              ))
            )}
        </div>

        {cart.length > 0 && (
          <div>
            <div className="cart-item row" style={{ color: "#AA8877FF" }}>
              <div className="col" style={{ minWidth: "240px" }}>
                {[data.taxRate, data.taxType].filter(Boolean).join(" ") || "VAT"}
              </div>
              <div className="col" style={{ minWidth: "90px", textAlign: "right" }}>
                {(data.taxValue || 0).toFixed(2)}
              </div>
              <div className="col" style={{ minWidth: "28px", padding: "0px"  }}>
                {data.currency}
              </div>
              <div className="col" >
              </div>
            </div>
            <hr></hr>

            <div className="cart-item row" >
              <div className="col" style={{ minWidth: "240px" }}>
                <strong>Total</strong>
              </div>
              <div className="col" style={{ minWidth: "90px", textAlign: "right" }}>
                <strong>{data.totalValue.toFixed(2)}</strong>
              </div>
              <div className="col" style={{ minWidth: "28px", padding: "0px" }}>
                <strong>{data.currency}</strong>
              </div>
              <div className="col" >
              </div>
            </div>
            <hr></hr>
            <div textalign="right" style={{ minWidth: "100px", textAlign: "center" }}>
              <Button variant="primary" onClick={checkout}>Checkout</Button>
            </div>
          </div>
        )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};